import React from 'react'

// material ui
import Box from '@mui/material/Box'

// components
import Typography from '@mui/material/Typography'
import Avatar from '@mui/material/Avatar'

const CamperStatusAvatar = ({ camper, status }) => {
  return (
    <Box pb={1} display='flex' width='100%'>
      <Box flexShrink={0}>
        <Avatar
          src={camper.largePhotoUrl}
          sx={{ width: '60px', height: '60px' }}
        />
      </Box>
      <Box ml={2} width='100%'>
        <Typography mt={1} variant='h3'>
          {camper.name}
        </Typography>
        {status && (
          <Typography color='text.secondary' variant='body1'>
            {status}
          </Typography>
        )}
      </Box>
    </Box>
  )
}

export default CamperStatusAvatar
